import React from "react";

import { Navbar } from "../../../components";
import { Babbel } from "./Babbel";

const BabbelProject = () => {
  return (
    <div className="app">
      <Navbar />
      <Babbel />
    </div>
  );
};

export default BabbelProject;
